import { useGet } from 'lib/api';
import { checkFeatureFlag } from '../utils';
import { apiUsers } from 'api/users';
import { FeatureFlags } from '../types';

export const useFeatureFlag = (feature: string) => {
  const { data } = useGet<FeatureFlags>(
    apiUsers.get.featureFlags,
    'feature-flags',
    undefined,
    undefined,
    false
  );
  return checkFeatureFlag(feature, data);
};

/**
 * Hook that returns both the feature flag value and loading state
 * Use this when you need to distinguish between "flag is false" and "flag is still loading"
 */
export const useFeatureFlagWithLoading = (feature: string) => {
  const { data, isLoading } = useGet<FeatureFlags>(
    apiUsers.get.featureFlags,
    'feature-flags',
    undefined,
    undefined,
    false
  );
  const hasAccess = checkFeatureFlag(feature, data);
  return { enabled: hasAccess, isLoading };
};
